import NotFoundPage from './404';

export default NotFoundPage;
